import {red} from "@mui/material/colors";

export function LogiCtrlError(props: {
    error: string
}) {
    return (
        <div style={{
            marginTop: 4,
            padding: "4px 8px",
            backgroundColor: red["50"],
            color: red["700"],
            borderRadius: 4,
            fontSize: 12,
            lineHeight: 1.4,
        }}>
            {props.error}
        </div>
    )
}